// extracted by mini-css-extract-plugin
export default {"card":"TrialCard_card__rolz2","closeButton":"TrialCard_closeButton__veq6N","info":"TrialCard_info__9o4qi"};